export const ErrorMessage = ({ message }: { message: string }) => {
  return (
    <div className="tw:flex tw:justify-center tw:items-center tw:p-4">
      {message}
    </div>
  );
};
